import React from 'react';
import { i18n } from 'config/locales';
import { CommonOnUpdate, CommonOnError, CommonRequired } from 'types/props';

import { LegalTechnologyUnauthorizedItemModel } from 'forms/sections/legal/technology/unauthorized/types';
import CheckboxGroup from 'components/Form/CheckboxGroup';
import Checkbox from 'components/Form/Checkbox';
import { CheckboxModel } from 'forms/shared/types';
import ValidationElement, {
  ValidationElementProps,
} from '../../../Form/ValidationElement/ValidationElement';

interface Props extends Partial<LegalTechnologyUnauthorizedItemModel['UnauthorizedActions']>, ValidationElementProps {
  onUpdate?: CommonOnUpdate
  onError?: CommonOnError
  required?: CommonRequired
  className?: string
  attribute?: string
}

export default class UnauthorizedActions extends ValidationElement<Props> {
  update = (response: CheckboxModel) => {
    if (!this.props.onUpdate) {
      return;
    }

    const selected = response.value;
    const list = [...(this.props.values || [])];

    if (list.includes(selected)) {
      list.splice(list.indexOf(selected), 1);
    } else {
      list.push(selected);
    }

    this.props.onUpdate({ values: list });
  };

  render() {
    return (
      <CheckboxGroup
        attribute={this.props.attribute}
        className={`action-manipulated option-list option-list-vertical ${
          this.props.className || ''
        }`.trim()}
        onError={this.props.onError}
        required={this.props.required}
        selectedValues={this.props.values || []}
      >
        <Checkbox
          name="workplace-action"
          label={i18n.t('legal.pvq.technology.unauthorized.actions.action1')}
          value={i18n.t('legal.pvq.technology.unauthorized.actions.action1')}
          className="workplace-action"
          onUpdate={this.update}
          onError={this.props.onError}
        />
        <Checkbox
          name="civil-actions"
          label={i18n.t('legal.pvq.technology.unauthorized.actions.action2')}
          value={i18n.t('legal.pvq.technology.unauthorized.actions.action2')}
          className="civil-actions"
          onUpdate={this.update}
          onError={this.props.onError}
        />
        <Checkbox
          name="criminal-action"
          label={i18n.t('legal.pvq.technology.unauthorized.actions.action3')}
          value={i18n.t('legal.pvq.technology.unauthorized.actions.action3')}
          className="criminal-action"
          onUpdate={this.update}
          onError={this.props.onError}
        />
        <Checkbox
          name="no-action"
          label={i18n.t('legal.pvq.technology.unauthorized.actions.action5')}
          value={i18n.t('legal.pvq.technology.unauthorized.actions.action5')}
          className="workplace-action"
          onUpdate={this.update}
          onError={this.props.onError}
        />
        <Checkbox
          name="security-actions"
          label={i18n.t('legal.pvq.technology.unauthorized.actions.action6')}
          value={i18n.t('legal.pvq.technology.unauthorized.actions.action6')}
          className="security-actions"
          onUpdate={this.update}
          onError={this.props.onError}
        />
        <Checkbox
          name="other-actions"
          label={i18n.t('legal.pvq.technology.unauthorized.actions.action4')}
          value={i18n.t('legal.pvq.technology.unauthorized.actions.action4')}
          className="other-actions"
          onUpdate={this.update}
          onError={this.props.onError}
        />
      </CheckboxGroup>
    );
  }
}

UnauthorizedActions.defaultProps = {
  values: [],
  onUpdate: (queue) => {},
  onError: (value, arr) => arr,
};
